/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_TitleInputs */

const en_model_fable_plan_title = /** @type {(inputs: Model_Fable_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fable`)
};

const id_model_fable_plan_title = /** @type {(inputs: Model_Fable_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fable`)
};

/**
* | output |
* | --- |
* | "Fable" |
*
* @param {Model_Fable_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_title = /** @type {((inputs?: Model_Fable_Plan_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_title(inputs)
	return en_model_fable_plan_title(inputs)
});